<template>
  <div>
    <!-- 搜索条件 -->
    <div class="search clear">
      <el-form :inline="true" size="mini">
        <el-form-item>
          <el-button type="success" @click="add">添加类别</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table_no_page">
      <el-table
        :data="tableData"
        size="small"
        height="100%"
        row-key="id"
        border
        style="width: 100%; height:100%;"
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column prop="name" label="类别名称"></el-table-column>
        <el-table-column prop="keyword" label="关键字"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column prop="seoTitle" label="SEO标题"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >编辑</el-button>
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 表单内容 -->
    <el-dialog class="dialog" :title="dialogTitle" :visible.sync="formVisible" width="40%">
      <ArtTypeForm></ArtTypeForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { tableData } from "../../../demo/art/arttypelist";
import ArtTypeForm from "./components/ArtTypeForm";
export default {
  name: "art_arttypelist",
  components:{
      ArtTypeForm
  },
  data() {
    return {
      tableData,
      formVisible: false,
      dialogTitle: "添加类别"
    };
  },
  methods: {
    //   添加
    add() {
      this.formVisible = true;
    }
  }
};
</script>

<style scoped>
</style>